<template>
	<div>
		<div class="w-tabs">
			<div class="tabs" style="padding:10px 30px 20px;border-bottom: 1px solid #eee;">
				<div class="tab" :class="{active: prescription.type == 1}" @click="handlePrescription(1)">用药处方<el-badge v-if="prescriptionItem.hospitalMedicineVO?.state==0" is-dot :class="['badge',`active${prescription.type}`]"></el-badge></div>
				<div class="tab" :class="{active: prescription.type == 2}" @click="handlePrescription(2)">饮食处方<el-badge v-if="prescriptionItem.hospitalFoodVO?.state==0" is-dot :class="['badge',`active${prescription.type}`]"></el-badge></div>
				<div class="tab" :class="{active: prescription.type == 3}" @click="handlePrescription(3)">运动处方<el-badge v-if="prescriptionItem.hospitalSportVO?.state==0" is-dot :class="['badge',`active${prescription.type}`]"></el-badge></div>
				<div class="tab" :class="{active: prescription.type == 4}" @click="handlePrescription(4)">心理处方<el-badge v-if="prescriptionItem.hospitalPsychologicalVO?.state==0" is-dot :class="['badge',`active${prescription.type}`]"></el-badge></div>
				<div class="tab" :class="{active: prescription.type == 5}" @click="handlePrescription(5)">睡眠处方<el-badge v-if="prescriptionItem.hospitalSleepVO?.state==0" is-dot :class="['badge',`active${prescription.type}`]"></el-badge></div>
				<div class="tab" :class="{active: prescription.type == 6}" @click="handlePrescription(6)">中医处方<el-badge v-if="prescriptionItem.hospitalChineseMedicineVO?.state==0" is-dot :class="['badge',`active${prescription.type}`]"></el-badge></div>
			</div>
			<div class="w-tabs-pane active">
				<div v-if="prescription.type == 1">
					<drug ref="drug" :patientId="patientId" :patientInfo='patientInfo' :recordId="recordId"  :datasources="datasources"  :medicalRecordDetail="medicalRecordDetail" @trigger-event="handlePrescription"></drug>
				</div>
				<div v-if="prescription.type == 2">
					<diet ref="diet" :patientId="patientId" :patientInfo='patientInfo' :recordId="recordId" 
						:onEvalShow="onEvalShow" :sideEvalList="getSideEvalList[0]" :datasources="datasources" :medicalRecordDetail="medicalRecordDetail" @trigger-event="handlePrescription"></diet>
				</div>
				<div v-if="prescription.type == 3">
					<sports ref="sports" :patientId="patientId" :patientInfo='patientInfo' :recordId="recordId" 
						:onEvalShow="onEvalShow" :sideEvalList="getSideEvalList[1]" :datasources="datasources" :medicalRecordDetail="medicalRecordDetail" @trigger-event="handlePrescription"></sports>
				</div>
				<div v-if="prescription.type == 4">
					<psychology ref="psychology" :patientId="patientId" :patientInfo='patientInfo' :recordId="recordId" 
						:onEvalShow="onEvalShow" :sideEvalList="getSideEvalList[2]" :datasources="datasources" :medicalRecordDetail="medicalRecordDetail" @trigger-event="handlePrescription"></psychology>
				</div>
				<div v-if="prescription.type == 5">
					<sleep ref="sleep" :patientId="patientId" :patientInfo='patientInfo' :recordId="recordId" 
						:onEvalShow="onEvalShow" :sideEvalList="getSideEvalList[4]" :datasources="datasources" :medicalRecordDetail="medicalRecordDetail" @trigger-event="handlePrescription"></sleep>
				</div>
				<div v-if="prescription.type == 6">
					<medicine ref="medicine" :patientId="patientId" :patientInfo='patientInfo' :recordId="recordId" 
						:onEvalShow="onEvalShow" :sideEvalList="getSideEvalList[3]" :datasources="datasources" :medicalRecordDetail="medicalRecordDetail" @trigger-event="handlePrescription"></medicine>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import api from '@/service/api.js';
	import Diet from './prescription/diet.vue';
	import Drug from './prescription/drug.vue';
	import Medicine from './prescription/medicine.vue';
	import Psychology from './prescription/psychology.vue';
	import Sleep from './prescription/sleep.vue';
	import Sports from './prescription/sports.vue';
    import { EventBus } from '@/event-bus.js';

	export default {
		components: {
			Diet,
			Drug,
			Medicine,
			Psychology,
			Sleep,
			Sports
		},
		computed: {
			getSideEvalList: function() {
				return this.$store.state.eval.sideList;
			}
		},
		props: {
			patientId: {
				required: true
			},
			patientInfo:{
				required: true
			},
			onEvalShow: {
				type: Function,
				default: null
			},
			recordId: {
				required: true
			},
			type: {
				required: true,
			},
			customerId: {
				required: true
			},
			datasources:{
				required: true
			}
		},
		data() {
			return {
				prescriptionItem: {},
				prescription: {
					type: 1
				},
				medicalRecordDetail:{},//科室床号
			}
		},
		watch: {
			type(newType,oldType) {
				console.log("oldTyp=========e:"+oldType);
				if(newType == 2){
					this.handlePrescription(4);
				}else if(newType == 3){
					this.handlePrescription(6);
				}else if(newType == 5){
					this.handlePrescription(3);
				}else if(newType == 6){
					this.handlePrescription(5);
				}else if(newType == 4){
					this.handlePrescription(2);
				}else{
					this.handlePrescription(1);
				}
			}
		},
		created() {
			this.init();
			let query = this.$route.query;
			if(query && query.p){
				this.prescription.type= Number(query.p);
				this.handlePrescription(Number(query.p))
			}
		},
		mounted(){
			EventBus.$on('trigger-event',(newVal) => {
				this.handlePrescription(Number(newVal))
			})
		},
		methods: {
			async init() {
				await this.loadDetail();
				await this.loadPrescription();
				this.$refs.drug.init(this.prescriptionItem);
			},
			async handlePrescription(v) {
				this.prescription.type = v;
				await this.loadPrescription();
				switch (v) {
					case 2:
						this.$refs.diet.init(this.prescriptionItem);
						break;
					case 3:
						this.$refs.sports.init(this.prescriptionItem);
						break;
					case 4:
						console.log(11111,v);
						this.$refs.psychology.init(this.prescriptionItem);
						break;
					case 5:
						this.$refs.sleep.init(this.prescriptionItem);
						break;
					case 6:
						this.$refs.medicine.init(this.prescriptionItem);
						break;
					default:
						this.$refs.drug.init(this.prescriptionItem);
						break;
				}
			},
			async loadPrescription() {
				console.log()
				if (this.recordId != ""&&this.customerId != 0) {
					this.isLoading = true;
					let res = await api.queryPrecription({
						customerId: this.customerId,
						recordId: this.recordId,
						datasources: this.datasources
					});
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.prescriptionItem = res.data;
				}
			},
			async loadDetail() {
				if (this.recordId != "") {
					this.isLoading = true;
					let res = await api.getFollowUp({
						recordId: this.recordId,
						datasources: this.datasources
					});
					this.isLoading = false;
					if (res.code != 1000) {
						return this.$message.error(res.message);
					}
					this.medicalRecordDetail = res.data;
					
				}
			},
			
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
	.w-tabs{
		.tabs{
			justify-content: normal;
			.active{
				.badge{
					display:none;
				}
			}
			.tab{

				position: relative;
			}
			.badge{
				position: absolute;
				
			}
			
		}
	}
</style>
